import { useMutation } from '@tanstack/react-query'

import { useApi } from 'contexts/api-context'

type PostResetPasswordProps = {
  username: string
}

export const useResetPassword = () => {
  const api = useApi()
  return useMutation<boolean, Error, PostResetPasswordProps>({
    mutationFn: async vars => {
      await api.post('/users/resetpassword', { body: JSON.stringify({ Email: vars.username }) })
      return true
    },
  })
}

export const useGetAuthHeader = () => {
  const api = useApi()
  return api.getAuthHeader()
}
